import { Container, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import { selectCurrentUser } from "../../redux/user/user.selector";

const useStyles = makeStyles((theme) => ({
  page: { justifyContent: "flex-start" },
}));
const HomePage = ({ currentUser }) => {
  const classes = useStyles();
  return (
    <div className={classes.page}>
      <PageHeaderComponent
        title="Ideen säen"
        subtitle="Das große Kreativspiel im Dekanat Wetterau-West"
      >
        <Typography variant="subtitle1">
          Siehe, ein Sämann ging hinaus, um zu säen… <br />
          <b>(Matthäus 13)</b>
        </Typography>
      </PageHeaderComponent>
      <Container maxWidth="md">
        <Typography>
          Mit netten Menschen freudige und spannende Stunden erleben,
          spielerisch neue Ideen für den pastoralen Weg erproben und mit etwas
          Glück eine öffentliche Auszeichnung als kreativste Gemeinde des
          Dekanats mit nach Hause nehmen…
          <br /> Das alles wartet auf Euch bei unserem großen Kreativspiel.
          Denkt Euch Projekte in Eurer Gemeinde aus, beschreibt sie auf der
          Spieleplattform, bewertet die Ideen anderer Gemeinden und schaut, wie
          Eure Ideen bei den anderen Gemeinden ankommen.
          <br /> <br />
          Interesse? Dann schnell angemeldet beim Dekanat Wetterau-West <br />
          E-Mail:{" "}
          <a href="mailto:ideen-saeen@kirche-wetterau.de">
            ideen-saeen@kirche-wetterau.de
          </a>{" "}
          <br />
          (Karlstr. 35, 61231 Bad Nauheim, Tel. 06032/931313)
        </Typography>
      </Container>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});
export default connect(mapStateToProps)(HomePage);
